import React, {useEffect, useState} from 'react';
import {ITabInfo} from "@/types";
import {Divider, Heading} from "@/components/atoms";
import {ButtonTab} from "@/components/organisms";
import {ExpandButton} from "@/components/molecules";
import {TitleWrap, Wrapper} from "@/components/templates/collectBoxedTab/CollectBoxedTab.styled";
import {useCommonParams} from "@/hooks";

const CollectBoxedTab = (props: ITabInfo) => {
  const {categories, onClick, title, needDivider} = props;
  const {page} = useCommonParams()
  const [isSpread, setIsSpread] = useState(false);

  useEffect(() => {
    return () => {
      setIsSpread(false);
    }
  }, [page])

  return (
    <Wrapper>
      {needDivider && <Divider/>}
      <TitleWrap>
        <Heading level={2} color="gray-800">
          {title}
        </Heading>
        <ExpandButton isSpread={isSpread} setIsSpread={setIsSpread}/>
      </TitleWrap>
      <ButtonTab categories={categories} onClick={onClick} isSpread={isSpread}/>
    </Wrapper>
  );
};

export default React.memo(CollectBoxedTab);